import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";
import { deleteCoupon, getAllCoupons } from "../../redux/services/couponSlice";

const Coupon = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getCouponData = useSelector((state) => state?.coupon?.couponData);

    const [page, setPage] = useState(0);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [confirm, setConfirm] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchData, setSearchData] = useState("");

    const limitOptions = [
        { value: 10, label: 10 },
        { value: 30, label: 30 },
        { value: 50, label: 50 },
        { value: 100, label: 100 },
    ];
    const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

    const getCoupons = useCallback(async () => {
        try {
            await dispatch(
                getAllCoupons({
                    page: page + 1,
                    limit: pageLimit,
                    searchData,
                })
            );
        } catch (error) {
            console.error("Error fetching coupons:", error);
        }
    }, [dispatch, page, pageLimit, searchData]);

    useEffect(() => {
        getCoupons();
    }, [getCoupons]);

    const deleteCouponData = async () => {
        try {
            const response = await dispatch(deleteCoupon(itemToDelete));
            toast.success(response?.payload?.message, {
                autoClose: 2000,
                pauseOnHover: false,
            });
            setConfirm(false);
            getCoupons();
        } catch (error) {
            console.error("Error deleting coupon:", error);
        }
    };

    const columns = [
        {
            header: "S/N",
            key: "index",
            render: (_, __, index) => page * pageLimit + index + 1,
        },
        { header: "Code", key: "code" },
        { header: "Description", key: "description" },
        { header: "Discount Type", key: "discountType" },
        { header: "Discount Value", key: "discountValue" },
        { header: "Audience", key: "audience" },
        { header: "Min Order Amount", key: "minOrderAmount" },
        { header: "Max Discount Amount", key: "maxDiscountAmount" },
        { header: "Usage Limit (Total)", key: "usageLimitTotal" },
        { header: "Usage Limit (Per User)", key: "usageLimitPerUser" },
        {
            header: "Valid From",
            key: "validFrom",
            render: (validFrom) => new Date(validFrom).toLocaleDateString(),
        },
        {
            header: "Valid Till",
            key: "validTill",
            render: (validTill) => new Date(validTill).toLocaleDateString(),
        },
    ];

    const actions = [
        {
            icon: <LuPencilLine className="w-5 h-5" />,
            onClick: (row) => {
                navigate(`${ROUTES.COUPON.ADD_EDIT}?couponId=${row._id}`, {
                    state: { row },
                });
            },
        },
        {
            icon: <AiOutlineDelete className="w-6 h-6" />,
            onClick: (row) => {
                setItemToDelete(row._id);
                setConfirm(true);
            },
        },
    ];

    return (
        <>
            <Table
                title="Coupons"
                buttonTitle="Add Coupon"
                showSearchbar={true}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                setSearchData={setSearchData}
                onAddClick={() => navigate(ROUTES.COUPON.ADD_EDIT)}
                columns={columns}
                data={getCouponData?.coupon_data || []}
                actions={actions}
                pageCount={getCouponData?.state?.page_limit}
                onPageChange={(selectedItem) => setPage(selectedItem.selected)}
                pageLimitOptions={limitOptions}
                selectedPageLimit={pageLimit}
                onPageLimitChange={setPageLimit}
            />
            {confirm && (
                <ConfirmationPage
                    topicName="Coupon"
                    confirm={confirm}
                    onDelete={deleteCouponData}
                    onCancel={() => setConfirm(false)}
                />
            )}
        </>
    );
};

export default Coupon;
